import React from 'react'
import { ProductWithActiveColour } from '../../types'

interface Props {
  product: ProductWithActiveColour
}

export const ProductRating: React.FC<Props> = ({ product }) => {
  if (product.stars) {
    return (
      <div className="productstars">
        <div
          className="productstars-wrap"
          style={{ width: `${product.stars * 20}%` }}
        >
          <span>★</span>
          <span>★</span>
          <span>★</span>
          <span>★</span>
          <span>★</span>
        </div>
        <div className="productstars-wrapbottom">
          <span>★</span>
          <span>★</span>
          <span>★</span>
          <span>★</span>
          <span>★</span>
        </div>
      </div>
    )
  }

  return <div className="productstarsfill" />
}
